module.exports = __webpack_public_path__ + "img/warning.509d9c75.svg";